import { defineStore } from 'pinia'
import { useUserStore } from './user-store'
import api from '../utils/axios'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: {
    id: number
    email: string
    fullname: string
    role: string
    active: boolean
    permissions: {
      isAdmin: boolean
      isSuperAdmin: boolean
      canWrite: boolean
      canRead: boolean
    }
    createdAt: string
    updatedAt: string
    avatar?: string
  } | null
  isAuthenticated: boolean
}

interface LoginResponse {
  accessToken: string
  refreshToken: string
  user: {
    id: number
    email: string
    fullname: string
    role: string
    active: boolean
    permissions: {
      isAdmin: boolean
      isSuperAdmin: boolean
      canWrite: boolean
      canRead: boolean
    }
    createdAt: string
    updatedAt: string
    avatar?: string
  }
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    isAuthenticated: !!localStorage.getItem('accessToken'),
  }),

  actions: {
    setAuthData(data: LoginResponse) {
      this.accessToken = data.accessToken
      this.refreshToken = data.refreshToken
      this.user = data.user
      this.isAuthenticated = true

      // 保存到 localStorage
      localStorage.setItem('accessToken', data.accessToken)
      localStorage.setItem('refreshToken', data.refreshToken)
      localStorage.setItem('user', JSON.stringify(data.user))
    },

    clearAuth() {
      this.accessToken = null
      this.refreshToken = null
      this.user = null
      this.isAuthenticated = false

      // 清除 localStorage
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('user')
    },

    async login(email: string, password: string) {
      try {
        const response = await api.post<LoginResponse>('/auth/login', {
          email,
          password,
        })

        if (response.data.accessToken) {
          this.setAuthData(response.data)
          // 登入成功後更新 user store
          const userStore = useUserStore()
          userStore.updateUserInfo()
          return true
        }
        return false
      } catch (error) {
        console.error('登入錯誤:', error)
        return false
      }
    },

    logout() {
      this.clearAuth()
    },
  },

  getters: {
    userEmail: (state) => state.user?.email,
    userId: (state) => state.user?.id,
  },
})
